import { createSlice } from '@reduxjs/toolkit'

import { getTaskMeta, putTaskMeta } from '../lib/api'

const initialState = {
  loading: [],
  loaded: [],
  cache: {}
}

const taskMetaCacheSlice = createSlice({
  name: 'taskMetaCache',
  initialState,
  reducers: {
    startLoad: (state, { payload }) => {
      state.loading.push(payload)
    },

    endLoad: (state, { payload }) => {
      state.loading = state.loading.filter(id => id !== payload)
      state.loaded.push(payload)
    },

    updateCache: (state, { payload }) => {
      const { id, data } = payload
      state.cache[id] = data
    }
  }
})

const { startLoad, endLoad, updateCache } = taskMetaCacheSlice.actions

export const loadMeta = id => {
  return async dispatch => {
    if (!id) {
      return
    }

    try {
      dispatch(startLoad(id))
      const data = await getTaskMeta(id)
      dispatch(updateCache({ id, data }))
    } catch (err) {
      console.error('Error loading task meta', err)
    } finally {
      dispatch(endLoad(id))
    }
  }
}

export const saveMeta = (id, newMeta) => {
  return async dispatch => {
    try {
      const data = await putTaskMeta(id, newMeta)
      const formatted = data.map(d => ({
        key: d.key,
        value: d.value,
        row: d.row,
        row_key: d.row_key
      }))
      dispatch(updateCache({ id, data: formatted }))
    } catch (err) {
      console.error('Error saving task meta', err)
    }
  }
}

export const selectTaskMetaCache = state => state.taskMetaCache

export default taskMetaCacheSlice.reducer
